import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { Helmet } from "react-helmet";
import Cookies from 'js-cookie';
import { useToast } from '../../components/ToastContext';
import Statusbar from '../../master_root/statusbar';
import { Createprojects } from './create_projact';
import Loadingimg from '../../components/loadingimg';
import Loading from '../../components/loading';
import { VscAdd } from 'react-icons/vsc';
import './projects.css';
import { Randomcode } from '../../components/rendom_code';
 
export default function Projects() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
 
  const [projectname, setProjectname] = useState('');
  const [description, setDescription] = useState('');
  const [projectdata, setProjectdata] = useState([]);
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };
 useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleGoBack();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  // Save new project
  const createProject = async () => {
    if (!projectname.trim() || !description.trim()) {
      showToast("Please enter both project name and description.");
      return;
    }

    setLoading(true);
    try {
      const puid = Randomcode(16); // Fallback for Randomcode
      const result = await Createprojects({puid, projectname, description });

      if (result.success) {
        showToast("Sent successfully");
        setProjectname('');
        setDescription('');
        fetchProjectsData(); // Refresh list
      } else {
        showToast("Failed: " + (result.error || "Unknown error"));
      }
    } catch (ex) {
      console.error("An error occurred:", ex);
    } finally {
      setLoading(false);
    }
  };

  // Fetch projects
  useEffect(() => {
  fetchProjectsData();
  }, []);

  const fetchProjectsData = async () => {
    setIsLoading(true);
    try {
      const smsQuery = query(collection(db, "projects"), 
      where("adminguid", "==", Cookies.get("adminguid"))
    
    );
      const smsSnapshot = await getDocs(smsQuery);
      const dataList = smsSnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data()
      }));
      setProjectdata(dataList);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      
      <Statusbar data={'Projects'} />
      <div className='app_header_height'></div>
      <div className="container_roots">
        <Helmet>
          <title>Browse Job Tasks | EditorTask - Find & Hire Creative Talent</title>
          <meta name="description" content="Discover the latest freelance job tasks listed on EditorTask. From video editing to digital marketing, connect with top talent across India." />
          <meta name="keywords" content="job listings, freelance tasks, hire editors, creative work, India job portal, remote jobs, task board, EditorTask jobs" />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />
          <meta property="og:title" content="Browse Job Tasks | EditorTask - Find & Hire Creative Talent" />
          <meta property="og:description" content="Explore freelance and project-based job tasks posted on EditorTask. Connect with skilled editors, designers, marketers, and more." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/jobs" />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
        </Helmet>

        <div className="container_size">
          <div className='post-container'>
            <div className='post_div'>
              <div className="ui-grid">
                {isLoading ? (
                  <Loading />
                ) : projectdata.length === 0 ? (
                  <p>No Project available.</p>
                ) : (
                  <div>                    
                        {projectdata.map((message) => (
                      <div className='ui-items'>
                    <table class="projects-table">
                      <tbody>

                          <tr
                            style={{ cursor: 'pointer' }}
                            key={message.id}
                          >
                            <td>
                              <div style={{ width: '100%' }}>
                                <div className="contact-title">
                                  {message.projectname?.substring(0, 150)}
                                </div>
                                <div className="contact-details">
                                  {message?.update_date_time?.toDate?.()?.toLocaleString?.() || 'No date'}
                                </div>
                              </div>
                            </td>
                            <td style={{ width: '30px', textAlign: 'center' }}>

                              <div className="alert-text">2</div>

                            </td>
                          </tr>
                           </tbody>
                    </table>
                  </div>
                        ))} 
                  </div>
                )}
              </div>
            </div>

            <div className='post_updates'>
              <div className="contact-title">New Projects</div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <input
                        placeholder='Name'
                        maxLength={50}
                        className='projects-input-box'
                        value={projectname}
                        onChange={(e) => setProjectname(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <textarea
                        className='projects-input-box'
                        maxLength={500}
                        placeholder='Description'
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className='button-ui' onClick={createProject}>
                        <VscAdd className='icon' /> {loading ? "Creating..." : "Create"}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
